/** sessionStorage bridge: partner apply form → personal registration page */
export const PARTNER_FORM_SUCCESS_KEY = "partnerformsuccess";

export function persistPartnerFormSuccess({ application_id, email, partner_type }) {
  try {
    sessionStorage.setItem(
      PARTNER_FORM_SUCCESS_KEY,
      JSON.stringify({
        application_id: application_id || null,
        email: (email || "").trim(),
        partner_type: partner_type || null,
        submitted_at: new Date().toISOString(),
      })
    );
  } catch {
    // sessionStorage unavailable — registration still works via email match
  }
}

export function clearPartnerFormSuccess() {
  try {
    sessionStorage.removeItem(PARTNER_FORM_SUCCESS_KEY);
  } catch {
    // ignore
  }
}
